<div class="flex-1 mt-4">
  <div>
    <h3 class="mb-1" data-tour="chart-accounts-title">Property-level tracking</h3>
    <p class="mb-8 mt-0 text-night-lighter">
      {{ 'CORE.PRODUCT_NAME' | transloco }} uses Classes to enable property-level tracking in Quickbooks.
    </p>
  </div>
  <div *ngIf="(canCreateTrackingCategories$ | async) === false">
    Tracking categories are not available for this connection.
  </div>
  <div *ngIf="formState$ | async as state" class="grid gap-3 grid-cols-2" formGroupName="properties">
    <div class="strong">{{ 'CORE.PRODUCT_NAME' | transloco }} Property</div>
    <div class="strong">Quickbooks Class</div>

    <ng-container *ngFor="let propertyEntry of state.data.properties.fieldMap | keyvalue">
      <div>{{ propertyEntry.value.label }}</div>

      <div *ngIf="(canCreateTrackingCategories$ | async) === true">
        <mat-form-field class="max-w-[300px] nopadding nomargin input__mini">
          <mat-select value="default" [formControlName]="propertyEntry.key">
            <mat-select-trigger>
              <div *ngIf="form.form.get(['properties', propertyEntry.key]).value === ''; else selectedClass">
                <ng-container *ngTemplateOutlet="defaultBadge" />
                Create new class
              </div>
              <ng-template #selectedClass>
                <ng-container
                  *ngIf="
                    (getDefaultTrackingCategory$(+propertyEntry.key) | async) ===
                    form.form.get(['properties', propertyEntry.key]).value
                  ">
                  <ng-container *ngTemplateOutlet="defaultBadge" />
                </ng-container>
                {{ (selectedTrackingCategory(+propertyEntry.key) | async)?.name }}
              </ng-template>
            </mat-select-trigger>

            <mat-option value="" *ngIf="(getDefaultTrackingCategory$(+propertyEntry.key) | async) === null">
              <ng-container *ngTemplateOutlet="defaultBadge" />
              Create new class
            </mat-option>

            <mat-option *ngFor="let option of trackingCategories$ | async" [value]="option.id">
              <ng-container *ngIf="(getDefaultTrackingCategory$(+propertyEntry.key) | async) === option.id">
                <ng-container *ngTemplateOutlet="defaultBadge" />
              </ng-container>
              {{ option.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #defaultBadge>
  <span class="!text-night-lighter px-2 py-1 rounded-2xl bg-smoke-lighter text__xsmall">New</span>
</ng-template>
